//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/SubdivisionMeshEdgeTopologyData.js";
import "../no/SubdivisionMeshFaceTopologyData.js";
import "../no/ugmath.js";
let d=[[],[[[],"Dispose",{},0,0],[["numVertices"],"GetVertexPositions",{R_:{vertices:""}},0,0],[["vertices"],"SetVertexPositions",{},1,0],[["numFaces"],"GetFaces",{R_:{faces:"SubdivisionMeshFaceTopologyData[]"}},0,0],[["numFaces"],"ReserveFaces",{},1,0],[["vertexIds"],"AddFace",{},1,0],[["numEdges"],"GetSharpEdges",{R_:{edges:"SubdivisionMeshEdgeTopologyData[]"}},0,0],[["vertex1Id","vertex2Id"],"SetSharp",{},2,0],[["numEdges"],"GetWeightedEdges",{R_:{edges:"SubdivisionMeshEdgeTopologyData[]"}},0,0],[["vertex1Id","vertex2Id","weight"],"SetWeight",{},3,0]],[]];
SPLM.SubdivisionMeshBodyTopologyData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SubdivisionMeshBodyTopologyData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;